export default function weeksMonthsYearsSince(date: Date) {
  const today = new Date();
  const daysBetween = (today.getTime() - date.getTime()) / (1000 * 3600 * 24);
  if (daysBetween <= 28) {
    return daysBetween < 14
      ? "1&nbsp;semaine"
      : `${Math.floor(daysBetween / 7)}&nbsp;semaines`;
  }
  if (daysBetween < 365) {
    return daysBetween <= 31
      ? "1&nbsp;mois"
      : `${Math.floor(daysBetween / 31)}&nbsp;mois`;
  }
  return daysBetween < 730
    ? "1&nbsp;an"
    : `${Math.floor(daysBetween / 365)}&nbsp;ans`;
}
